import { QUERY_KEYS } from "@/src/config";

export const planQueryKeys = {
  /** `status=INACTIVE,PLANNED` + `sort=PRIORITY` + `enrich_hash_data=true` — For You / Checkup 共用，React Query 去重 */
  diagnosisGoals: () =>
    [
      QUERY_KEYS.GOAL_LIST,
      "plan-diagnosis-goals",
      "inactive-planned",
      "enrich-hash",
    ] as const,
  forYouStats: () => [QUERY_KEYS.GOAL_LIST, "plan-for-you-stats"] as const,
  activityBannerRecords: (ownerId: string) =>
    [QUERY_KEYS.GOAL_LIST, "plan-activity-banner-records", ownerId] as const,
  /** B 类 subtitle · ACTIVE goals goal.name lookup（与 A 类 INACTIVE/PLANNED 列表独立） */
  activityBannerGoalTitles: (ownerId: string) =>
    [
      QUERY_KEYS.GOAL_LIST,
      "plan-activity-banner-goal-titles",
      ownerId,
    ] as const,
  activityCalendar: (
    weekStartIso: string,
    weekEndIso: string,
    todayIso: string,
  ) =>
    [
      QUERY_KEYS.GOAL_LIST,
      "plan-activity-calendar",
      weekStartIso,
      weekEndIso,
      todayIso,
    ] as const,
  /** @deprecated use diagnosisGoals */
  forYou: () => [QUERY_KEYS.GOAL_LIST, "plan-for-you"] as const,
  /** @deprecated use diagnosisGoals */
  checkupRings: () => [QUERY_KEYS.GOAL_LIST, "plan-checkup-rings"] as const,
};
